const makeArrFromObj = (obj) => {
  const entries = Object.entries(obj);
  const renderData = entries.map(([key, value]) => ({ title: key, total: value }));
  return renderData;
};
export default makeArrFromObj;
